/* eslint-disable react-hooks/exhaustive-deps */
import {
  FormControl,
  InputLabel,
  MenuItem,
  Stack,
  TextField,
} from "@mui/material";
import Select from "../../../components/SearchableSelect";
import ConvoyDialog from "../../../components/ConvoyDialog";
import { useEffect, useState } from "react";
import { useUpgradeControlPlane } from "../../../api/tessellGcpDeployments";

const UpgradeDialog = ({
  deploymentStage,
  controlPlane,
  open,
  resetDialog,
  callback,
  displayNotification,
}) => {
  const [upgradeStep, setUpgradeStep] = useState("all");
  const [releaseLabel, setReleaseLabel] = useState("");

  const {
    postData: upgradeControlPlane,
    response: upgradeControlPlaneResp,
    responseStatus: upgradeControlPlaneStatus,
  } = useUpgradeControlPlane(deploymentStage, controlPlane);

  useEffect(() => {
    displayNotification(
      upgradeControlPlaneResp,
      upgradeControlPlaneStatus,
      callback
    );
  }, [upgradeControlPlaneResp, upgradeControlPlaneStatus]);

  useEffect(() => {
    setUpgradeStep("all");
    setReleaseLabel("");
  }, [controlPlane]);

  const handleDialogConfirm = () => {
    upgradeControlPlane({
      releaseLabel: releaseLabel,
      upgradeStep: upgradeStep,
    });
    resetDialog();
  };

  return (
    <ConvoyDialog
      open={open}
      variant="confirmation"
      title={`Upgrade ${controlPlane}`}
      handleDialogConfirm={handleDialogConfirm}
      resetDialog={resetDialog}
    >
      <Stack direction="row" alignItems="flex-start" spacing={1.5}>
        <TextField
          fullWidth
          label="Release label"
          value={releaseLabel}
          onChange={(e) => {
            setReleaseLabel(e.target.value);
          }}
        />
        <FormControl fullWidth>
          <InputLabel id="select-label">upgrade step</InputLabel>
          <Select
            labelId="select-app-label"
            id="select-step"
            value={upgradeStep || " "}
            label="App"
            onChange={(e) => setUpgradeStep(e.target.value)}
          >
            {["deploy_terraform", "deploy_workflow", "deploy_ui", "all"].map(
              (step, i) => (
                <MenuItem value={step} key={i}>
                  {step}
                </MenuItem>
              )
            )}
          </Select>
        </FormControl>
      </Stack>
    </ConvoyDialog>
  );
};

export default UpgradeDialog;

export const useUpgradeDialog = (
  deploymentStage,
  callback = () => {},
  displayNotification = () => {}
) => {
  const [open, setOpen] = useState(false);
  const [controlPlane, setControlPlane] = useState("");

  return {
    upgradeDialog: (
      <UpgradeDialog
        open={open}
        resetDialog={() => setOpen(false)}
        callback={callback}
        displayNotification={displayNotification}
        deploymentStage={deploymentStage}
        controlPlane={controlPlane}
      />
    ),
    setOpenUpgradeDialog: (controlPlane) => {
      if (controlPlane) {
        setOpen(true);
        setControlPlane(controlPlane);
      }
    },
  };
};
